// Vendor
import "bootstrap";
import "jarallax";

// Theme
// import "./aos";
import initScrollAnimations from "./animations";
import "./bigpicture";
import "./bootstrap";
import "./choices";
import "./countup";
import "./dropzone";
import "./highlight";
import "./isotope";
import "./jarallax";
import "./map";
import "./modal";
import "./navbar-dropdown";
import "./navbar";
import "./popover";
import "./pricing";
import "./quill";
import "./smooth-scroll";
import "./tooltip";
import "./typed";
// User
import "./user.js";

import "./navbaractive.js"
import "./sanity-client.js"
// import "./home-redesign.js"
// import "./technology-page.js"
// import "./services-landing.js"

// import "./case-studies.js"
// import "./caseStudyDetail.js"
import "./cs-nlp-models.js"
import "./cs-saas-adtech.js"
import "./aboutPage.js"
import "./leadershipPage.js"
import "./culturePage.js"
import "./lookingForPage.js"
import "./internshipsPage.js"
import "./contactPage.js"
import "./privacy-policy.js"
import "./footer.js"
import "./cookie-consent.js"

// Initialize scroll animations
initScrollAnimations();